import React from "react";
import {useGlobalMenu} from "@src/hooks/useGlobalMenu";
import helpers from "@src/../js/helpers";

export function HeaderActionWishlist({ settings, isMobile }) {

    const { section } = settings;

    const text_style = section.header_font_type;

    return (
        <>
            {settings.globals.enable_wishlist === "true" &&
                section.show_wishlist_in_header && (
                    <a href="/pages/wishlist" className="header-action__link antialiased [&>svg]:h-[28px]">
                        {section.show_text_no_icons_wishlist ? (
                            <a className={`${text_style}`}>WISHLIST</a>
                        ) : (
                            <i className="icon-wishlist w-[16px] h-[16px]"></i>
                        )}
                    </a>
                )}
        </>
    );
}
